
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_6005_19065)"}},[_c('path',{attrs:{"d":"M2.916 10.018c.058 0 .116-.002.174-.005l.834 1.444a.757.757 0 001.033.277l3.268-1.887a.757.757 0 00.277-1.033l-.129-.224.892.036a.895.895 0 00.81-1.342l-.994-1.722a1.766 1.766 0 00-1.748-3.028L6.34.813a.895.895 0 00-1.567.031L3.444 3.373a.326.326 0 01-.136.141l-1.853 1.07a2.912 2.912 0 001.46 5.434zm4.936-.83a.007.007 0 01-.002.009l-3.268 1.887h-.005a.007.007 0 01-.004-.002l-.707-1.224c.174-.06.342-.137.501-.23l1.853-1.07a.325.325 0 01.191-.046l1.075.043.366.634zm.401-5.996A1.016 1.016 0 018.7 4.901l-.985-1.706c.176-.05.362-.05.538-.003zM5.561 1.115a.134.134 0 01.129.073l3.736 6.471a.145.145 0 01-.131.217l-.428-.017-3.63-6.287.199-.38a.135.135 0 01.125-.077zM3.683 4.163c.181-.102.33-.256.425-.442l.716-1.363L7.98 7.824l-1.54-.062a1.072 1.072 0 00-.595.147l-.282.163-2.162-3.746.282-.162zM1.83 5.234l.921-.532 2.163 3.746-.922.532A2.163 2.163 0 111.83 5.233zm9.302-3.21a.375.375 0 01.375.649l-1.195.69a.375.375 0 01-.375-.65l1.195-.69zm-.514 2.586l1.195.69a.375.375 0 01-.375.649l-1.195-.69a.375.375 0 11.375-.65zM8.58.165a.375.375 0 01.375.375v1.38a.375.375 0 01-.75 0V.54A.375.375 0 018.58.165z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_6005_19065"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    